import type { UseQueryResult } from "@tanstack/react-query";

import { apiClient } from "app/modules/api-client";
import { useLLMReportQuery } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMReportQuery";
import type {
    ILLMWidgetRequestParams,
    ISentimentOverviewResponse,
} from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

export const useSentimentOverviewData = (
    params: ILLMWidgetRequestParams,
    options?: { enabled?: boolean },
): UseQueryResult<ISentimentOverviewResponse> =>
    useLLMReportQuery<ISentimentOverviewResponse, ILLMWidgetRequestParams>(
        "sentimentSummary",
        apiClient.AiTracker.aiTrackerReportsSentimentAnalysisOverviewList,
        params,
        options,
    );
